import { ruleRunner } from 'validations/ruleRunner';
import { maxLength, required, ruleIfNotValue } from 'validations/rules';

const chargeTypes = { SINGLE_PAYMENT: 'N', SIGNATURE: 'A', FREE: 'G' };

const customMessage = (text: any) => {
  if (text) {
    return null;
  } else {
    return () => 'Selecione pelo menos uma opção (Boleto, Cartão, etc)';
  }
};

const setFields = (chargeType: string) => {
  if (chargeType === chargeTypes.SINGLE_PAYMENT) return ['allows_boleto', 'allows_card', 'allows_pix', 'allows_paypal', 'allows_multiple_cards'];

  if (chargeType === chargeTypes.SIGNATURE) return ['allows_boleto', 'allows_card', 'allows_pix'];

  return ['allows_boleto', 'allows_card'];
};

const atLeastOneFieldMatch = (ruleRun: any) => {
  return (text: any, state: any) => {
    let charge_type = state['charge_type'];
    if (charge_type === chargeTypes.FREE) {
      return null;
    }

    const fields = setFields(charge_type);

    let match = false;

    for (let i = 0; i < fields.length; i++) {
      if (!match) {
        match = state[fields[i]] === true;
      }
    }
    if (match) {
      return null;
    }
    return ruleRun(text);
  };
};

const Validations = [
  ruleRunner('allows_payment_types', 'Opções de pagamento', atLeastOneFieldMatch(customMessage)),
  ruleRunner('friendly_name', 'nome exibido na fatura de cartão', maxLength(10)),
  ruleRunner('friendly_name', 'nome exibido na fatura de cartão', ruleIfNotValue('charge_type', chargeTypes.FREE, required)),
];

export default Validations;
